import PropTypes from 'prop-types';
import React from 'react';
import Button from '@99designs/react-components/components/Button';
import { PopoverCard } from '@99designs/react-components/components/PopoverCard';
import { FormattedMessage } from 'react-intl';
import onboardingPrompt from 'contest/components/onboarding-prompts/onboardingPrompt';
import contestStageSelector from 'contest/components/onboarding-prompts/contestStageSelector';

const FinalistButtonOnboardingPromptComponent = ({ dismiss, children }) => {
    return (
        <PopoverCard
            layerSelector="#content-overlay-layer"
            variations={['onboarding-prompt']}
            card={
                <div>
                    <h5 className="heading heading--h5 heading--pacific">
                        <FormattedMessage id="contest_finalist_button_onboarding_title" />
                    </h5>
                    <p>
                        <FormattedMessage id="contest_finalist_button_onboarding_message" />
                    </p>
                    <Button variations={['info', 'small']} onClick={dismiss}>
                        <FormattedMessage id="contest_finalist_button_onboarding_button" />
                    </Button>
                </div>
            }
        >
            <span onClick={dismiss}>{children}</span>
        </PopoverCard>
    );
};

FinalistButtonOnboardingPromptComponent.propTypes = {
    dismiss: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default contestStageSelector(
    ['selecting-finalists'],
    onboardingPrompt('finalist-button', 400, FinalistButtonOnboardingPromptComponent)
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/FinalistButtonOnboardingPrompt.js